/* TALISHKO — Paid gift-wrap toggle (cart page + mini-cart drawer). Custom, reversible.
   Checkbox adds/removes the "Gift Wrapping" product; a paid line item that shows in the order admin.
   Drawer toggle is JS-injected so it appears the instant the drawer opens (not only after a reload). */
(function () {
  if (window.__tlskGiftWrap) return; window.__tlskGiftWrap = true;

  var CFG     = window.TLSK_GIFTWRAP || {};
  var VARIANT = String(CFG.variantId || '');
  var PID     = String(CFG.productId || '');
  var TITLE   = CFG.title || 'Add gift wrapping';
  var SUBT    = CFG.subtitle || 'Wrapped in Talishko packaging, ready to gift';
  var PRICEL  = CFG.priceLabel || '';
  var FREE    = CFG.free === true;
  if (!VARIANT) return;

  var GIFT_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path></svg>';

  var busy = false, tmr = null;

  function giftLine(cart) {
    return (cart.items || []).filter(function (i) {
      return String(i.variant_id) === VARIANT || (PID && String(i.product_id) === PID);
    })[0];
  }

  // inner markup (without the outer <label>) — lets us diff-update without recreating the node
  function innerHTML() {
    return '<input type="checkbox" id="tlsk-gw-drawer" data-tlsk-giftwrap>' +
           '<span class="tlsk-gw__box">' + GIFT_SVG + '</span>' +
           '<span class="tlsk-gw__tx"><span class="tlsk-gw__t">' + TITLE + '</span><span class="tlsk-gw__s">' + SUBT + '</span></span>' +
           '<span class="tlsk-gw__price">' + PRICEL + '</span>';
  }

  function setChecked(cb, on) {
    if (!cb) return;
    if (document.activeElement !== cb && cb.checked !== on) cb.checked = on;
    var w = cb.closest('.tlsk-gw');
    if (w) w.classList.toggle('is--on', on);
  }

  // reflect the cart state on every checkbox (page + drawer)
  function syncChecks(present) {
    document.querySelectorAll('[data-tlsk-giftwrap]').forEach(function (cb) { setChecked(cb, present); });
  }

  // inject / update / remove the drawer toggle so it is always present when the drawer has items
  function ensureDrawerToggle(cart) {
    var bottom = document.querySelector('#t4s-mini_cart .t4s-drawer__bottom');
    if (!bottom) return;
    var has = cart.items && cart.items.length > 0;
    var el = bottom.querySelector(':scope > .tlsk-gw');
    if (!has) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('label');
      el.className = 'tlsk-gw' + (FREE ? ' is--free' : '');
      el.setAttribute('for', 'tlsk-gw-drawer');
      el.innerHTML = innerHTML();               // built once; only checked state changes afterwards
      bottom.insertBefore(el, bottom.firstChild);
    }
    setChecked(el.querySelector('input'), !!giftLine(cart));
  }

  function updateBubbles(cart) {
    var wrap = document.querySelector('#t4s-mini_cart'); if (wrap) wrap.setAttribute('data-ccount', cart.item_count);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.innerHTML = cart.item_count; });
    document.documentElement.classList.toggle('t4s-cart-count-0', cart.item_count === 0);
  }

  // drawer refresh: pull the fresh mini_cart section (item list + native bottom re-render with the new cart)
  function rerenderDrawer() {
    return fetch('/?section_id=mini_cart').then(function (r) { return r.text(); }).then(function (html) {
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['#t4s-tab-minicart [data-cart-items]'].forEach(function (sel) {
          var f = doc.querySelector(sel), l = document.querySelector(sel);
          if (f && l) l.innerHTML = f.innerHTML;
        });
      } catch (e) {}
    });
  }

  function reconcile() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (!busy) { syncChecks(!!giftLine(cart)); ensureDrawerToggle(cart); } return cart; })
      .catch(function () {});
  }

  function afterChange(inDrawer) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBubbles(cart);
        if (inDrawer) {
          return rerenderDrawer().then(function () {
            return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
          }).then(function (c2) { syncChecks(!!giftLine(c2)); ensureDrawerToggle(c2); });
        }
        // cart page: full reload so the line item + totals reflect natively
        window.location.reload();
      });
  }

  function setGift(on, inDrawer) {
    if (busy) return;
    busy = true;
    var p;
    if (on) {
      p = fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: VARIANT, quantity: 1 })
      });
    } else {
      p = fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var gl = giftLine(cart); if (!gl) return;
          return fetch('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: gl.key, quantity: 0 })
          });
        });
    }
    p.then(function () { return afterChange(inDrawer); })
     .then(function () { busy = false; })
     .catch(function () { busy = false; reconcile(); });
  }

  // delegated change handler — works after any re-render
  document.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('[data-tlsk-giftwrap]');
    if (!cb) return;
    var inDrawer = !!cb.closest('#t4s-mini_cart');
    setGift(cb.checked, inDrawer);
  }, false);

  function debounced() { clearTimeout(tmr); tmr = setTimeout(reconcile, 320); }

  function start() {
    reconcile();
    // keep the drawer toggle present/synced through the theme's async drawer re-renders
    var drawer = document.querySelector('#t4s-mini_cart');
    if (drawer) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t.closest && t.closest('.tlsk-gw, .tlsk-rewards, .tlsk-totals, .tlsk-tools, .tlsk-items-lbl, .tlsk-min-order, .tlsk-cart-bnpl')) continue; // ignore our own + rewards.js writes
          debounced();
          return;
        }
      });
      mo.observe(drawer, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // re-sync when the mini-cart opens (drawer may have just been lazy-injected)
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-action="open-minicart"], [data-cart-icon-bubble], .t4s-cart-icon')) {
      setTimeout(reconcile, 350);
    }
  }, false);
})();
